import { Content, Title } from '@radix-ui/react-dialog';
import React, { ComponentPropsWithoutRef, ElementRef, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import { SheetOverlay } from './sheet-overlay';
import { SheetPortal } from './sheet-portal';

export const SHEET_CLOSE_ANIMATION_MS = 300;

enum SheetSideVariant {
  BOTTOM = 'inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom',
  CENTER = 'left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 data-[state=closed]:fade-out data-[state=open]:fade-in',
  LEFT = 'inset-y-0 left-0 h-full w-fit border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left',
  RIGHT = 'inset-y-0 right-0 h-full w-fit  border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right',
  TOP = 'inset-x-0 top-0 border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top',
}
export type SheetContentProps = {
  overlayClassName?: string;
  side?: keyof typeof SheetSideVariant;
} & ComponentPropsWithoutRef<typeof Content>;

export const SheetContent = forwardRef<ElementRef<typeof Content>, SheetContentProps>(
  ({ children, className, overlayClassName, side = 'LEFT', ...props }, ref) => {
    return (
      <SheetPortal>
        <Title />
        <SheetOverlay className={overlayClassName} />
        <Content
          className={twMerge(
            'fixed z-[51] w-fit gap-4 bg-white p-6 shadow-lg transition ease-in-out data-[state=closed]:duration-300 data-[state=open]:duration-500 data-[state=open]:animate-in data-[state=closed]:animate-out',
            SheetSideVariant[side],
            className,
          )}
          ref={ref}
          {...props}
        >
          {children}
        </Content>
      </SheetPortal>
    );
  },
);
SheetContent.displayName = Content.displayName;
